export const tasks = [{ value: "My Tasks", label: "My Tasks" }];

export const locationType = [
  { value: "office", label: "Office" },
  { value: "factory", label: "Factory" },
  { value: "service_station", label: "Service Station" },
  { value: "stadium", label: "Stadium" },
  { value: "retail_store", label: "Retail Store" },
  { value: "hotel", label: "Hotel" },
  { value: "storage_unit", label: "Storage Unit" },
  { value: "marina", label: "Marina" },
  { value: "warehouse", label: "Warehouse" },
  { value: "distribution_center", label: "Distribution Center" },
  { value: "laboratory", label: "Laboratory" },
  { value: "call_center", label: "Call Center" },
  { value: "farm", label: "Farm" },
  { value: "amusement_park", label: "Amusement Park" },
  { value: "airport", label: "Airport" },
  { value: "bus_station", label: "Bus Satation" },
  { value: "ship_yard", label: "Shipyard" },
  { value: "parking_garage", label: "Parking Garage" },
];

export const listVehicleType = [
  { value: "car", label: "Car" },
  { value: "truck", label: "Truck" },
  { value: "bus", label: "Bus" },
  { value: "motorbike", label: "Motorbike" },
  { value: "tractor", label: "Tractor" },
  { value: "van", label: "Van" },
  { value: "flatbed", label: "Flatbed" },
  { value: "semi_truck", label: "Semi Truck" },
  { value: "garbage_truck", label: "Garbage Truck" },
];

export const stateCodes = [
  { label: "Select", value: "undefined", isDisabled: true, hide: true },
  { label: "AL", value: "AL" },
  { label: "AK", value: "AK" },
  { label: "AS", value: "AS" },
  { label: "AZ", value: "AZ" },
  { label: "AR", value: "AR" },
  { label: "AA", value: "AA" },
  { label: "AE", value: "AE" },
  { label: "AP", value: "AP" },
  { label: "CA", value: "CA" },
  { label: "CO", value: "CO" },
  { label: "CT", value: "CT" },
  { label: "DE", value: "DE" },
  { label: "DC", value: "DC" },
  { label: "FL", value: "FL" },
  { label: "GA", value: "GA" },
  { label: "GU", value: "GU" },
  { label: "HI", value: "HI" },
  { label: "ID", value: "ID" },
  { label: "IL", value: "IL" },
  { label: "IN", value: "IN" },
  { label: "IA", value: "IA" },
  { label: "KS", value: "KS" },
  { label: "KY", value: "KY" },
  { label: "LA", value: "LA" },
  { label: "ME", value: "ME" },
  { label: "MH", value: "MH" },
  { label: "MD", value: "MD" },
  { label: "MA", value: "MA" },
  { label: "MI", value: "MI" },
  { label: "FM", value: "FM" },
  { label: "MN", value: "MN" },
  { label: "MS", value: "MS" },
  { label: "MO", value: "MO" },
  { label: "MT", value: "MT" },
  { label: "NE", value: "NE" },
  { label: "NV", value: "NV" },
  { label: "NH", value: "NH" },
  { label: "NJ", value: "NJ" },
  { label: "NM", value: "NM" },
  { label: "NY", value: "NY" },
  { label: "NC", value: "NC" },
  { label: "ND", value: "ND" },
  { label: "MP", value: "MP" },
  { label: "OH", value: "OH" },
  { label: "OK", value: "OK" },
  { label: "OR", value: "OR" },
  { label: "PW", value: "PW" },
  { label: "PA", value: "PA" },
  { label: "PR", value: "PR" },
  { label: "RI", value: "RI" },
  { label: "SC", value: "SC" },
  { label: "SD", value: "SD" },
  { label: "TN", value: "TN" },
  { label: "TX", value: "TX" },
  { label: "UT", value: "UT" },
  { label: "VT", value: "VT" },
  { label: "VI", value: "VI" },
  { label: "VA", value: "VA" },
  { label: "WA", value: "WA" },
  { label: "WV", value: "WV" },
  { label: "WI", value: "WI" },
  { label: "WY", value: "WY" },
];

export const isoCodes = [
  { value: "AF", label: "Afghanistan" },
  { value: "AX", label: "Åland Islands" },
  { value: "AL", label: "Albania" },
  { value: "DZ", label: "Algeria" },
  { value: "AS", label: "American Samoa" },
  { value: "AD", label: "Andorra" },
  { value: "AO", label: "Angola" },
  { value: "AI", label: "Anguilla" },
  { value: "AQ", label: "Antarctica" },
  { value: "AG", label: "Antigua & Barbuda" },
  { value: "AR", label: "Argentina" },
  { value: "AM", label: "Armenia" },
  { value: "AW", label: "Aruba" },
  { value: "AC", label: "Ascension Island" },
  { value: "AU", label: "Australia" },
  { value: "AT", label: "Austria" },
  { value: "AZ", label: "Azerbaijan" },
  { value: "BS", label: "Bahamas" },
  { value: "BH", label: "Bahrain" },
  { value: "BD", label: "Bangladesh" },
  { value: "BB", label: "Barbados" },
  { value: "BY", label: "Belarus" },
  { value: "BE", label: "Belgium" },
  { value: "BZ", label: "Belize" },
  { value: "BJ", label: "Benin" },
  { value: "BM", label: "Bermuda" },
  { value: "BT", label: "Bhutan" },
  { value: "BO", label: "Bolivia" },
  { value: "BA", label: "Bosnia & Herzegovina" },
  { value: "BW", label: "Botswana" },
  { value: "BV", label: "Bouvet Island" },
  { value: "BR", label: "Brazil" },
  { value: "IO", label: "British Indian Ocean Territory" },
  { value: "VG", label: "British Virgin Islands" },
  { value: "BN", label: "Brunei" },
  { value: "BG", label: "Bulgaria" },
  { value: "BF", label: "Burkina Faso" },
  { value: "BI", label: "Burundi" },
  { value: "KH", label: "Cambodia" },
  { value: "CM", label: "Cameroon" },
  { value: "CA", label: "Canada" },
  { value: "IC", label: "Canary Islands" },
  { value: "CV", label: "Cape Verde" },
  { value: "BQ", label: "Caribbean Netherlands" },
  { value: "KY", label: "Cayman Islands" },
  { value: "CF", label: "Central African Republic" },
  { value: "EA", label: "Ceuta & Melilla" },
  { value: "TD", label: "Chad" },
  { value: "CL", label: "Chile" },
  { value: "CN", label: "China" },
  { value: "CX", label: "Christmas Island" },
  { value: "CP", label: "Clipperton Island" },
  { value: "CC", label: "Cocos (Keeling) Islands" },
  { value: "CO", label: "Colombia" },
  { value: "KM", label: "Comoros" },
  { value: "CG", label: "Congo - Brazzaville" },
  { value: "CD", label: "Congo - Kinshasa" },
  { value: "CK", label: "Cook Islands" },
  { value: "CR", label: "Costa Rica" },
  { value: "CI", label: "Côte d’Ivoire" },
  { value: "HR", label: "Croatia" },
  { value: "CU", label: "Cuba" },
  { value: "CW", label: "Curaçao" },
  { value: "CY", label: "Cyprus" },
  { value: "CZ", label: "Czechia" },
  { value: "DK", label: "Denmark" },
  { value: "DG", label: "Diego Garcia" },
  { value: "DJ", label: "Djibouti" },
  { value: "DM", label: "Dominica" },
  { value: "DO", label: "Dominican Republic" },
  { value: "EC", label: "Ecuador" },
  { value: "EG", label: "Egypt" },
  { value: "SV", label: "El Salvador" },
  { value: "GQ", label: "Equatorial Guinea" },
  { value: "ER", label: "Eritrea" },
  { value: "EE", label: "Estonia" },
  { value: "SZ", label: "Eswatini" },
  { value: "ET", label: "Ethiopia" },
  { value: "FK", label: "Falkland Islands" },
  { value: "FO", label: "Faroe Islands" },
  { value: "FJ", label: "Fiji" },
  { value: "FI", label: "Finland" },
  { value: "FR", label: "France" },
  { value: "GF", label: "French Guiana" },
  { value: "PF", label: "French Polynesia" },
  { value: "TF", label: "French Southern Territories" },
  { value: "GA", label: "Gabon" },
  { value: "GM", label: "Gambia" },
  { value: "GE", label: "Georgia" },
  { value: "DE", label: "Germany" },
  { value: "GH", label: "Ghana" },
  { value: "GI", label: "Gibraltar" },
  { value: "GR", label: "Greece" },
  { value: "GL", label: "Greenland" },
  { value: "GD", label: "Grenada" },
  { value: "GP", label: "Guadeloupe" },
  { value: "GU", label: "Guam" },
  { value: "GT", label: "Guatemala" },
  { value: "GG", label: "Guernsey" },
  { value: "GN", label: "Guinea" },
  { value: "GW", label: "Guinea-Bissau" },
  { value: "GY", label: "Guyana" },
  { value: "HT", label: "Haiti" },
  { value: "HM", label: "Heard & McDonald Islands" },
  { value: "HN", label: "Honduras" },
  { value: "HK", label: "Hong Kong SAR China" },
  { value: "HU", label: "Hungary" },
  { value: "IS", label: "Iceland" },
  { value: "IN", label: "India" },
  { value: "ID", label: "Indonesia" },
  { value: "IR", label: "Iran" },
  { value: "IQ", label: "Iraq" },
  { value: "IE", label: "Ireland" },
  { value: "IM", label: "Isle of Man" },
  { value: "IL", label: "Israel" },
  { value: "IT", label: "Italy" },
  { value: "JM", label: "Jamaica" },
  { value: "JP", label: "Japan" },
  { value: "JE", label: "Jersey" },
  { value: "JO", label: "Jordan" },
  { value: "KZ", label: "Kazakhstan" },
  { value: "KE", label: "Kenya" },
  { value: "KI", label: "Kiribati" },
  { value: "XK", label: "Kosovo" },
  { value: "KW", label: "Kuwait" },
  { value: "KG", label: "Kyrgyzstan" },
  { value: "LA", label: "Laos" },
  { value: "LV", label: "Latvia" },
  { value: "LB", label: "Lebanon" },
  { value: "LS", label: "Lesotho" },
  { value: "LR", label: "Liberia" },
  { value: "LY", label: "Libya" },
  { value: "LI", label: "Liechtenstein" },
  { value: "LT", label: "Lithuania" },
  { value: "LU", label: "Luxembourg" },
  { value: "MO", label: "Macao SAR China" },
  { value: "MG", label: "Madagascar" },
  { value: "MW", label: "Malawi" },
  { value: "MY", label: "Malaysia" },
  { value: "MV", label: "Maldives" },
  { value: "ML", label: "Mali" },
  { value: "MT", label: "Malta" },
  { value: "MH", label: "Marshall Islands" },
  { value: "MQ", label: "Martinique" },
  { value: "MR", label: "Mauritania" },
  { value: "MU", label: "Mauritius" },
  { value: "YT", label: "Mayotte" },
  { value: "MX", label: "Mexico" },
  { value: "FM", label: "Micronesia" },
  { value: "MD", label: "Moldova" },
  { value: "MC", label: "Monaco" },
  { value: "MN", label: "Mongolia" },
  { value: "ME", label: "Montenegro" },
  { value: "MS", label: "Montserrat" },
  { value: "MA", label: "Morocco" },
  { value: "MZ", label: "Mozambique" },
  { value: "MM", label: "Myanmar (Burma)" },
  { value: "NA", label: "Namibia" },
  { value: "NR", label: "Nauru" },
  { value: "NP", label: "Nepal" },
  { value: "NL", label: "Netherlands" },
  { value: "NC", label: "New Caledonia" },
  { value: "NZ", label: "New Zealand" },
  { value: "NI", label: "Nicaragua" },
  { value: "NE", label: "Niger" },
  { value: "NG", label: "Nigeria" },
  { value: "NU", label: "Niue" },
  { value: "NF", label: "Norfolk Island" },
  { value: "KP", label: "North Korea" },
  { value: "MK", label: "North Macedonia" },
  { value: "MP", label: "Northern Mariana Islands" },
  { value: "NO", label: "Norway" },
  { value: "OM", label: "Oman" },
  { value: "PK", label: "Pakistan" },
  { value: "PW", label: "Palau" },
  { value: "PS", label: "Palestinian Territories" },
  { value: "PA", label: "Panama" },
  { value: "PG", label: "Papua New Guinea" },
  { value: "PY", label: "Paraguay" },
  { value: "PE", label: "Peru" },
  { value: "PH", label: "Philippines" },
  { value: "PN", label: "Pitcairn Islands" },
  { value: "PL", label: "Poland" },
  { value: "PT", label: "Portugal" },
  { value: "PR", label: "Puerto Rico" },
  { value: "QA", label: "Qatar" },
  { value: "RE", label: "Réunion" },
  { value: "RO", label: "Romania" },
  { value: "RU", label: "Russia" },
  { value: "RW", label: "Rwanda" },
  { value: "WS", label: "Samoa" },
  { value: "SM", label: "San Marino" },
  { value: "ST", label: "São Tomé & Príncipe" },
  { value: "SA", label: "Saudi Arabia" },
  { value: "SN", label: "Senegal" },
  { value: "RS", label: "Serbia" },
  { value: "SC", label: "Seychelles" },
  { value: "SL", label: "Sierra Leone" },
  { value: "SG", label: "Singapore" },
  { value: "SX", label: "Sint Maarten" },
  { value: "SK", label: "Slovakia" },
  { value: "SI", label: "Slovenia" },
  { value: "SB", label: "Solomon Islands" },
  { value: "SO", label: "Somalia" },
  { value: "ZA", label: "South Africa" },
  { value: "GS", label: "South Georgia & South Sandwich Islands" },
  { value: "KR", label: "South Korea" },
  { value: "SS", label: "South Sudan" },
  { value: "ES", label: "Spain" },
  { value: "LK", label: "Sri Lanka" },
  { value: "BL", label: "St. Barthélemy" },
  { value: "SH", label: "St. Helena" },
  { value: "KN", label: "St. Kitts & Nevis" },
  { value: "LC", label: "St. Lucia" },
  { value: "MF", label: "St. Martin" },
  { value: "PM", label: "St. Pierre & Miquelon" },
  { value: "VC", label: "St. Vincent & Grenadines" },
  { value: "SD", label: "Sudan" },
  { value: "SR", label: "Suriname" },
  { value: "SJ", label: "Svalbard & Jan Mayen" },
  { value: "SE", label: "Sweden" },
  { value: "CH", label: "Switzerland" },
  { value: "SY", label: "Syria" },
  { value: "TW", label: "Taiwan" },
  { value: "TJ", label: "Tajikistan" },
  { value: "TZ", label: "Tanzania" },
  { value: "TH", label: "Thailand" },
  { value: "TL", label: "Timor-Leste" },
  { value: "TG", label: "Togo" },
  { value: "TK", label: "Tokelau" },
  { value: "TO", label: "Tonga" },
  { value: "TT", label: "Trinidad & Tobago" },
  { value: "TA", label: "Tristan da Cunha" },
  { value: "TN", label: "Tunisia" },
  { value: "TR", label: "Turkey" },
  { value: "TM", label: "Turkmenistan" },
  { value: "TC", label: "Turks & Caicos Islands" },
  { value: "TV", label: "Tuvalu" },
  { value: "UM", label: "U.S. Outlying Islands" },
  { value: "VI", label: "U.S. Virgin Islands" },
  { value: "UG", label: "Uganda" },
  { value: "UA", label: "Ukraine" },
  { value: "AE", label: "United Arab Emirates" },
  { value: "GB", label: "United Kingdom" },
  { value: "US", label: "United States" },
  { value: "UY", label: "Uruguay" },
  { value: "UZ", label: "Uzbekistan" },
  { value: "VU", label: "Vanuatu" },
  { value: "VA", label: "Vatican City" },
  { value: "VE", label: "Venezuela" },
  { value: "VN", label: "Vietnam" },
  { value: "WF", label: "Wallis & Futuna" },
  { value: "EH", label: "Western Sahara" },
  { value: "YE", label: "Yemen" },
  { value: "ZM", label: "Zambia" },
  { value: "ZW", label: "Zimbabwe" },
];

export const categoryType = [
  {
    value: "reporting_company",
    label: "Reporting Company",
    isHighlighted: true,
    isDisabled: true,
  },
  { value: 1, label: "Company facilities" },
  { value: 2, label: "Company vehicles" },
  {
    value: "upstream",
    label: "Upstream",
    isHighlighted: true,
    isDisabled: true,
  },
  {
    value: 3,
    label: "Purchased electricity, steam, heating & cooling for own use",
  },
  { value: 4, label: "Purchased goods & services" },
  { value: 5, label: "Capital goods" },
  { value: 6, label: "Fuel & energy related activities" },
  { value: 7, label: "Transportation & distribution" },
  { value: 8, label: "Waste generated in operations" },
  { value: 9, label: "Business travel" },
  { value: 10, label: "Employee commuting" },
  { value: 11, label: "Leased assets" },
  {
    value: "downstream",
    label: "Downstream",
    isHighlighted: true,
    isDisabled: true,
  },
  { value: 12, label: "Transportation & distribution" },
  { value: 13, label: "Processing of sold products" },
  { value: 14, label: "Use of sold products" },
  { value: 15, label: "End-of-life treatment of solid products" },
  { value: 16, label: "Leased assets" },
  { value: 17, label: "Franchises" },
  { value: 18, label: "Investments" },
];

export const industryType = [{ value: "Replace", label: "Replace" }];

export const transactionsSortType = [
  { value: "sort_by=name&sort_order=ASC", label: "A - Z" },
  {
    value: "sort_by=tr_amount&sort_order=DESC",
    label: "Spend: High to Low",
  },
  {
    value: "sort_by=tr_amount&sort_order=ASC",
    label: "Spend: Low to High",
  },
  {
    value: "sort_by=tr_footprint&sort_order=DESC",
    label: "Footprint: High to Low",
  },
  {
    value: "sort_by=tr_footprint&sort_order=ASC",
    label: "Footprint: Low to High",
  },
];

export const suppliersSortType = [
  { value: "sort_by=name&sort_order=ASC", label: "A - Z" },
  {
    value: "sort_by=total_spend&sort_order=DESC",
    label: "Spend: High to Low",
  },
  {
    value: "sort_by=total_spend&sort_order=ASC",
    label: "Spend: Low to High",
  },
  {
    value: "sort_by=carbon_intensity&sort_order=DESC",
    label: "Intensity: High to Low",
  },
  {
    value: "sort_by=carbon_intensity&sort_order=ASC",
    label: "Intensity: Low to High",
  },
  {
    value: "sort_by=total_footrpint&sort_order=DESC",
    label: "Footprint: High to Low",
  },
  {
    value: "sort_by=total_footrpint&sort_order=ASC",
    label: "Footprint: Low to High",
  },
];

export const permissionListType = [
  { value: "undefined", label: "Select", isDisabled: true, hide: true },
  { value: 1, label: "Full Access" },
  { value: 2, label: "Partial Access" },
  { value: 3, label: "View Only" },
];

export const listFuelType = [
  { value: "undefined", label: "Select", isDisabled: true, hide: true },
  { value: "gas", label: "Gas" },
  { value: "diesel", label: "Diesel" },
];

export const computingTypeList = [
  { value: "CPU", label: "CPU" },
  { value: "Storage", label: "Storage" },
  { value: "Memory", label: "Memory" },
];

export const shippingTypeList = [
  { value: "Air", label: "Air" },
  { value: "Rail", label: "Rail" },
  { value: "Road", label: "Road" },
  { value: "Sea", label: "Sea" },
  { value: "Multiple methods", label: "Multiple methods" },
];

export const shippingTypeServicesList = [
  { value: "Upstream", label: "Upstream" },
  { value: "Downstream", label: "Downstream" },
  { value: "Both", label: "Both" },
];

export const additionalTravelTypeList = [
  { value: "Flight", label: "Flight" },
  { value: "Accomodation", label: "Accomodation" },
  { value: "Flight & Accomodation", label: "Flight & Accomodation" },
  { value: "Other", label: "Other" },
];

export const wasteTypeList = [
  { value: "Construction", label: "Construction" },
  // { value: "General", label: "General" },
  { value: "Electrical", label: "Electrical" },
  { value: "Metal", label: "Metal" },
  { value: "Paper & Cardboard", label: "Paper & Cardboard" },
  { value: "Plastic", label: "Plastic" },
  { value: "Food & Organic", label: "Food & Organic" },
  { value: "Glass", label: "Glass" },
];

export const fuelServiceList = [
  { value: "Land", label: "Land" },
  { value: "Air", label: "Air" },
  { value: "Water", label: "Water" },
];

export const landFuelTypeList = [
  { value: "Petroleum", label: "Petroleum" },
  { value: "Diesel", label: "Diesel" },
];

export const airFuelTypeList = [{ value: "Jet Fuel", label: "Jet Fuel" }];

export const waterFuelTypeList = [
  { value: "MGO", label: "MGO" },
  { value: "HFO", label: "HFO" },
  { value: "LNG", label: "LNG" },
  { value: "LSFHO", label: "LSFHO" },
];

export const fuelCardProviderList = [
  { value: "import data file", label: "Import data file" },
  { value: "import data manually", label: "Import data manually" },
];

export const flightClassList = [
  { label: "First", value: "First" },
  { label: "Business", value: "Business" },
  { label: "Economy", value: "Economy" },
];

export const energyUnitList = [{ label: "KWH", value: "kWh" }];

export const storageUnitList = [
  { label: "MB", value: "MB" },
  { label: "GB", value: "GB" },
  { label: "TB", value: "TB" },
];

export const timeUnitList = [
  { label: "MS", value: "MS" },
  { label: "SEC", value: "S" },
  { label: "MIN", value: "M" },
  { label: "Hours", value: "H" },
  { label: "Days", value: "D" },
];

export const storageTypeList = [
  { label: "SSD", value: "SSD" },
  { label: "HDD", value: "HDD" },
];

export const weightUnitList = [
  // { label: "GT", value: "gt" },
  // { label: "MT", value: "mt" },
  // { label: "T", value: "t" },
  { label: "KG", value: "kg" },
  // { label: "G", value: "g" },
  // { label: "MG", value: "mg" },
];

export const liquidUnitList = [{ label: "Gal", value: "gal" }];

export const mapYourFootprintList = [
  { value: "country", label: "Countries" },
  { value: "subsidiary", label: "Subsidiaries" },
  { value: "location", label: "Locations" },
  { value: "supplier", label: "Suppliers" },
];

export const fleetSortType = [
  { value: "undefined", label: "Sort", isDisabled: true, hide: true },
  {
    value: "sort_by=total_carbon_footprint&sort_order=DESC",
    label: "High to Low",
  },
  {
    value: "sort_by=total_carbon_footprint&sort_order=ASC",
    label: "Low to High",
  },
  { value: "sort_by=name&sort_order=ASC", label: "A to Z" },
  { value: "sort_by=name&sort_order=DESC", label: "Z to A" },
];

export const locationsSortType = [
  { value: "undefined", label: "Sort", isDisabled: true, hide: true },
  {
    value: "sort_by=total_footrpint&sort_order=DESC",
    label: "High to Low",
  },
  {
    value: "sort_by=total_footrpint&sort_order=ASC",
    label: "Low to High",
  },
  { value: "sort_by=name&sort_order=ASC", label: "A to Z" },
  // { value: "sort_by=name&sort_order=DESC", label: "Z to A" },
];

export const awsRegionTypes = [
  { value: "af_south_1", label: "af_south_1" },
  { value: "ap_east_1", label: "ap_east_1" },
  { value: "ap_northeast_1", label: "ap_northeast_1" },
  { value: "ap_northeast_2", label: "ap_northeast_2" },
  { value: "ap_northeast_3", label: "ap_northeast_3" },
  { value: "ap_south_1", label: "ap_south_1" },
  { value: "ap_southeast_1", label: "ap_southeast_1" },
  { value: "ap_southeast_2", label: "ap_southeast_2" },
  { value: "ca_central_1", label: "ca_central_1" },
  { value: "cn_north_1", label: "cn_north_1" },
  { value: "cn_northwest_1", label: "cn_northwest_1" },
  { value: "eu_central_1", label: "eu_central_1" },
  { value: "eu_north_1", label: "eu_north_1" },
  { value: "eu_south_1", label: "eu_south_1" },
  { value: "eu_west_1", label: "eu_west_1" },
  { value: "eu_west_2", label: "eu_west_2" },
  { value: "eu_west_3", label: "eu_west_3" },
  { value: "me_south_1", label: "me_south_1" },
  { value: "sa_east_1", label: "sa_east_1" },
  { value: "us_east_1", label: "us_east_1" },
  { value: "us_east_2", label: "us_east_2" },
  { value: "us_gov_east_1", label: "us_gov_east_1" },
  { value: "us_gov_west_1", label: "us_gov_west_1" },
  { value: "us_west_1", label: "us_west_1" },
  { value: "us_west_2", label: "us_west_2" },
];

export const azureRegionTypes = [
  { value: "australia_central", label: "australia_central" },
  { value: "australia_central_2", label: "australia_central_2" },
  { value: "australia_east", label: "australia_east" },
  { value: "australia_south_east", label: "australia_south_east" },
  { value: "brazil", label: "brazil" },
  { value: "brazil_south", label: "brazil_south" },
  { value: "brazil_south_east", label: "brazil_south_east" },
  { value: "canada", label: "canada" },
  { value: "canada_central", label: "canada_central" },
  { value: "canada_east", label: "canada_east" },
  { value: "central_us", label: "central_us" },
  { value: "east_asia", label: "east_asia" },
  { value: "east_us", label: "east_us" },
  { value: "east_us_2", label: "east_us_2" },
  { value: "east_us_3", label: "east_us_3" },
  { value: "france", label: "france" },
  { value: "france_central", label: "france_central" },
  { value: "france_south", label: "france_south" },
  { value: "germany", label: "germany" },
  { value: "germany_north", label: "germany_north" },
  { value: "germany_west_central", label: "germany_west_central" },
  { value: "india", label: "india" },
  { value: "india_central", label: "india_central" },
  { value: "india_south", label: "india_south" },
  { value: "india_west", label: "india_west" },
  { value: "japan", label: "japan" },
  { value: "japan_east", label: "japan_east" },
  { value: "japan_west", label: "japan_west" },
  { value: "korea", label: "korea" },
  { value: "korea_east", label: "korea_east" },
  { value: "korea_south", label: "korea_south" },
  { value: "north_central_us", label: "north_central_us" },
  { value: "north_europe", label: "north_europe" },
  { value: "norway", label: "norway" },
  { value: "norway_east", label: "norway_east" },
  { value: "norway_west", label: "norway_west" },
  { value: "south_africa", label: "south_africa" },
  { value: "south_africa_north", label: "south_africa_north" },
  { value: "south_africa_west", label: "south_africa_west" },
  { value: "south_central_us", label: "south_central_us" },
  { value: "southeast_asia", label: "southeast_asia" },
  { value: "sweden_central", label: "sweden_central" },
  { value: "switzerland", label: "switzerland" },
  { value: "switzerland_north", label: "switzerland_north" },
  { value: "switzerland_west", label: "switzerland_west" },
  { value: "uk", label: "uk" },
  { value: "uk_south", label: "uk_south" },
  { value: "uk_west", label: "uk_west" },
  { value: "united_arab_emirates", label: "united_arab_emirates" },
  {
    value: "united_arab_emirates_central",
    label: "united_arab_emirates_central",
  },
  { value: "united_arab_emirates_north", label: "united_arab_emirates_north" },
  { value: "west_central_us", label: "west_central_us" },
  { value: "west_europe", label: "west_europe" },
  { value: "west_us", label: "west_us" },
  { value: "west_us_2", label: "west_us_2" },
  { value: "west_us_3", label: "west_us_3" },
];

export const gcpRegionTypes = [
  { value: "asia_east_1", label: "asia_east_1" },
  { value: "asia_east_2", label: "asia_east_2" },
  { value: "asia_northeast_1", label: "asia_northeast_1" },
  { value: "asia_northeast_2", label: "asia_northeast_2" },
  { value: "asia_northeast_3", label: "asia_northeast_3" },
  { value: "asia_south_1", label: "asia_south_1" },
  { value: "asia_south_2", label: "asia_south_2" },
  { value: "asia_southeast_1", label: "asia_southeast_1" },
  { value: "asia_southeast_2", label: "asia_southeast_2" },
  { value: "australia_southeast_1", label: "australia_southeast_1" },
  { value: "australia_southeast_2", label: "australia_southeast_2" },
  { value: "europe_central_2", label: "europe_central_2" },
  { value: "europe_north_1", label: "europe_north_1" },
  { value: "europe_west_1", label: "europe_west_1" },
  { value: "europe_west_2", label: "europe_west_2" },
  { value: "europe_west_3", label: "europe_west_3" },
  { value: "europe_west_4", label: "europe_west_4" },
  { value: "europe_west_6", label: "europe_west_6" },
  { value: "northamerica_northeast_1", label: "northamerica_northeast_1" },
  { value: "southamerica_east_1", label: "southamerica_east_1" },
  { value: "us_central_1", label: "us_central_1" },
  { value: "us_east_1", label: "us_east_1" },
  { value: "us_east_4", label: "us_east_4" },
  { value: "us_west_1", label: "us_west_1" },
  { value: "us_west_2", label: "us_west_2" },
  { value: "us_west_3", label: "us_west_3" },
  { value: "us_west_4", label: "us_west_4" },
];

export const supplierByScopeFor12ListType = [
  { value: "country", label: "Countries" },
  { value: "subsidiary", label: "Subsidiaries" },
  { value: "location", label: "Locations" },
  { value: "department", label: "Departments" },
  // { value: "supplier", label: "Suppliers" },
  { value: "industry", label: "Industries" },
];

export const supplierByScopeFor3ListType = [
  { value: "country", label: "Countries" },
  { value: "industry", label: "Industries" },
  { value: "project", label: "Projects" },
  // { value: "supplier", label: "Suppliers" },
  { value: "location", label: "Locations" },
  { value: "department", label: "Departments" },
  { value: "subsidiary", label: "Subsidiaries" },
  { value: "categories", label: "Categories" },
];

export const benchmarkingSortType = [
  { label: "Carbon Footprint", value: "sort_by=footprint&sort_order=DESC" },
  {
    label: "Carbon Intensity",
    value: "sort_by=carbon_intensity&sort_order=DESC",
  },
  { label: "Total ESG score", value: "sort_by=esg_score&sort_order=DESC" },
];

export const targetTermType = [
  { value: "1", label: "Long Term Target" },
  { value: "2", label: "Mid Term Target" },
  { value: "3", label: "Short Term Target" },
  { value: "4", label: "Yearly Target" },
];

export const myTasksFilterType = ({ MyTaskTypeIconObject }) => {
  return [
    {
      label: "Filter",
      value: "undefined",
      icon: "",
      isDisabled: true,
      hide: true,
    },
    {
      label: "Travel",
      value: "travel",
      icon: MyTaskTypeIconObject["travel"],
    },
    {
      label: "Accomodation",
      value: "accomodation",
      icon: MyTaskTypeIconObject["accomodation"],
    },
    {
      label: "Freight",
      value: "freight",
      icon: MyTaskTypeIconObject["freight"],
    },
    {
      label: "Computing",
      value: "computing",
      icon: MyTaskTypeIconObject["computing"],
    },
    {
      label: "Utility",
      value: "utility_electricity",
      icon: MyTaskTypeIconObject["utility_electricity"],
    },
    {
      label: "Unknown Supplier",
      value: "unknown_supplier",
      icon: MyTaskTypeIconObject["unknown_supplier"],
    },
    {
      label: "Additional Travel",
      value: "additional_travel",
      icon: MyTaskTypeIconObject["additional_travel"],
    },
    {
      label: "Waste",
      value: "waste",
      icon: MyTaskTypeIconObject["waste"],
    },
    {
      label: "Fuel",
      value: "fuel",
      icon: MyTaskTypeIconObject["fuel"],
    },
    {
      label: "Fuel Card Provider",
      value: "fuel_card",
      icon: MyTaskTypeIconObject["fuel_card"],
    },
  ];
};
